// extracted by mini-css-extract-plugin
export var aiStarIcon = "_b0-4";
export var closeButton = "_b0-6";
export var dismissButton = "_b0-3";
export var editImageWithAiContainer = "_b0-8";
export var imageUploadWrapper = "_b0-7";
export var misspelledWord = "_b0-5";
export var spellCheckContainer = "_b0-2";
export var spin = "_b0-1";
export var spinning = "_b0-0";